import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "@/shared/api/http-client";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Never retry auth/permission/not-found or any 4xx — they won't get
        // better on retry. 5xx and network hiccups get a small budget.
        if (error instanceof ApiError) {
          if (error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
